import { shopifyQueryKey } from '../ShopifyAppContext'

export function studyBuilderInitialStateQueryKey(
  shopDomain: string,
  orgId: string | null = null,
  connectionId: string | null = null,
) {
  return shopifyQueryKey(shopDomain, orgId, connectionId, ['study-builder-initial-state'] as const)
}

export function studyRunPreflightQueryKey(
  shopDomain: string,
  orgId: string | null,
  connectionId: string | null,
  studyId: string | null,
) {
  return shopifyQueryKey(shopDomain, orgId, connectionId, ['shopify-study-run-dry-run', studyId] as const)
}
